import { formatNumber, parseNumber } from 'libphonenumber-js';
import isEmpty from 'lodash/isEmpty.js';
import isObject from 'lodash/isObject.js';
import isArray from 'lodash/isArray.js';
import cloneDeep from 'lodash/cloneDeep.js';

export function merge(to, from) {
    Object.keys(to).forEach(key => {
        if (!from.hasOwnProperty(key)) {
            return;
        }

        if (isArray(from[key])) {
            to[key] = cloneDeep(from[key]);
        } else if (isObject(from[key])) {
            merge(to[key], from[key]);
        } else {
            to[key] = from[key];
        }
    });
}

// Sort array by key. Return a new instance.
export function sort(array, key) {
    return array.concat().sort((a, b) => {
        if (key) {
            return a[key].localeCompare(b[key]);
        }

        return a.localeCompare(b);
    });
}

export function formatPhone(value) {
    if (!value) return '';

    const parsedNumber = parseNumber(value, 'CA');

    return isEmpty(parsedNumber) ? '' : formatNumber(parsedNumber, 'International');
}

export function formatFullName(object) {
    let name = object && object.first_name ? object.first_name : '';

    name += ' ';
    name += object && object.last_name ? object.last_name : '';

    return name.trim();
}

export function nl2br(value) {
    if (typeof value === 'undefined' || value === null) return '';

    return (`${value}`).replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g, '$1<br>$2');
}
